import LegalLayout from "../components/LegalLayout";
import Markdown from "../components/Markdown";
import { useContent } from "../context/ContentContext";
import { DEFAULT_AGB } from "../lib/legalDefaults";

export default function AGB() {
  const { content } = useContent();
  const legal = content?.legal || {};
  const text = legal.agb?.body || DEFAULT_AGB;
  const updated = legal.agb?.updated || "Mai 2026";
  return (
    <LegalLayout eyebrow="Legal · 03" title="AGB" updated={updated}>
      <Markdown source={text} />
    </LegalLayout>
  );
}
